<template>

	

  <div id="app">

  	<div class="">
	    <router-view/>
	    <vue-snotify></vue-snotify>
    </div>
  </div>
</template>



<script>
import Vue from "vue";

export default Vue.extend({
  components: {},

  data: function() {
    return {};
  },
  methods: {},

  mounted: function() {}
});
</script>
<style lang="scss">
@import "~vue-snotify/styles/material";

@import "~bootstrap/dist/css/bootstrap.css";
@import "~bootstrap-vue/dist/bootstrap-vue.css";
@import "assets/_custome.scss";
</style>
